import { TranslateService } from '@ngx-translate/core';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { ColumnConfigItem, Icon } from '../models/coaching.global.model';

const expandiconclass = 'unfold-more-vertical';
const compressiconclass = 'unfold-less-vertical';
const compacttitle = 'Compact View';
const fulltitle = 'Full View';
const hidecolumntitle = 'Hide Column';
const headerswithcontrolsclass =
    'opportunity-header absorbing-column with-column-controls';
const headercontentoaclass = 'header-content-oa';

const compressedstyles = {
    colstyle: { width: '30%' },
    styles: {
        width: '30%',
        'min-width': '150px',
    },
};

const missedexpandstyles = {
    colstyle: { width: '50%' },
    styles: {
        width: '50%',
        'min-width': '150px',
    },
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const toggleCompressHandler = (d: ColumnConfigItem) => {
    let createdCacheInCurrentTransaction = false;

    if (!d.cacheStyleProps || Object.keys(d.cacheStyleProps).length === 0) {
        d.cacheStyleProps = {
            styles: d.styles ? d.styles : undefined,
            colstyle: d.colstyle ? d.colstyle : undefined,
        };
        createdCacheInCurrentTransaction = true;
    }

    // expand
    if (d.compactView === false) {
        let styles = d.cacheStyleProps.styles;
        let colstyle = d.cacheStyleProps.colstyle;
        if (d.templateName === 'missedopps') {
            styles = missedexpandstyles.styles;
            colstyle = missedexpandstyles.colstyle;
        }

        d.styles = Object.assign({}, ...styles, {});
        d.colstyle = Object.assign({}, ...colstyle, {});

        if (!createdCacheInCurrentTransaction) {
            d.cacheStyleProps = undefined;
        }

        // compress
    } else {
        // if (d.templateName === 'missedopps') {
        d.styles = compressedstyles.styles;
        d.colstyle = compressedstyles.colstyle;
        // } else {
        //     d.styles = oppscompressedstyles.styles;
        //     d.colstyle = oppscompressedstyles.colstyle;
        // }
    }
};

export function toggleIcon(icon: Icon): boolean {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (icon && icon.state !== undefined) {
        icon.state = !icon.state;
        if (icon.class && icon.counter !== icon.class.length - 1) {
            icon.counter++;
        } else icon.counter = 0;

        return icon.state;
    }

    return null;
}

export function getTeamColumnConfigItemsConfig(
    tls: TranslateService,
    totalMissedOpps?: number,
): ColumnConfigItem[] {
    let colindex = 0;

    const performerCol = {
        templateName: null,
        displayByDefault: true,
        active: true,
        colstyle: {
            width: '15rem',
            'min-width': '4rem',
        },
        styles: {
            'text-align': 'left',
            'background-color': 'white',
            'vertical-align': 'bottom',
        },
        class: 'members-header',
        cellstyles: {
            'text-align': 'left',
        },
    };

    const oaCol: any = {
        templateName: 'oascore',
        header: tls.instant(TranslationKeyMap._7463_OA),
        displayByDefault: true,
        colstyle: {
            width: '70px',
        },
        active: true,
        styles: {},
        class: 'oa-header',
        headerContentClass: headercontentoaclass,
        cellstyles: {
            'text-align': 'left',
        },
    };
    oaCol.icon = [
        new Icon(
            {
                class: ['chevron-up', 'chevron-down'],
                counter: 0,
                state: true,
                action: 'sortTeamByScore',
                actionParams: null,
            },
            TeamColumnConfigIconId.OA_TOGGLE,
        ),
    ];

    const coachedCol: any = {
        templateName: 'coachedopps',
        header: tls.instant(TranslationKeyMap._7473_COACHED_OPPORTUNITIES),
        displayByDefault: true,
        active: true,
        colstyle: { width: '50%' },
        styles: {
            width: '50%',
            'min-width': '150px',
        },
        class: headerswithcontrolsclass,
        headerContentClass: headercontentoaclass,
        cellstyles: {
            'text-align': 'center',
        },
        elastic: true,
        actionSideEffects: {
            toggleCompress: toggleCompressHandler,
        },
    };
    coachedCol.icon = [
        new Icon(
            {
                iconName: 'toggle',
                class: ['eye-off-outline'],
                title: [tls.instant(hidecolumntitle)],
                counter: 0,
                state: false,
                action: 'toggleColumnByIndex',
                actionParams: [2], // column index, icon index
            },
            TeamColumnConfigIconId.COACHED_TOGGLE,
        ),
        new Icon(
            {
                iconName: 'compress',
                class: [compressiconclass, expandiconclass],
                title: [tls.instant(compacttitle), tls.instant(fulltitle)],
                counter: 0,
                state: false,
                action: 'compressColumnByIndex',
                actionParams: [2, 'toggleCompress'],
            },
            TeamColumnConfigIconId.COACHED_COMPRESS,
        ),
    ];

    const uncoachedCol: any = {
        templateName: 'uncoachedopps',
        header: tls.instant(TranslationKeyMap._7399_UNCOACHED_OPPORTUNITIES), // ,
        displayByDefault: true,
        active: true,
        colstyle: { width: '50%' },
        styles: {
            width: '50%',
            'min-width': '150px',
        },
        class: headerswithcontrolsclass,
        headerContentClass: headercontentoaclass,
        cellstyles: {
            'text-align': 'center',
        },
        elastic: true,
        actionSideEffects: {
            toggleCompress: toggleCompressHandler,
        },
    };
    uncoachedCol.icon = [
        new Icon(
            {
                iconName: 'toggle',
                class: ['eye-off-outline'],
                title: [hidecolumntitle],
                counter: 0,
                state: false,
                action: 'toggleColumnByIndex',
                actionParams: [3],
            },
            TeamColumnConfigIconId.UNCOACHED_TOGGLE,
        ),
        new Icon(
            {
                iconName: 'compress',
                class: [compressiconclass, expandiconclass],
                title: [tls.instant(compacttitle), tls.instant(fulltitle)],
                counter: 0,
                state: false,
                action: 'compressColumnByIndex',
                actionParams: [3, 'toggleCompress'],
            },
            TeamColumnConfigIconId.UNCOACHED_COMPRESS,
        ),
    ];

    const missedCol: any = {
        templateName: 'missedopps',
        bindToId: 99,
        compactView: true,
        header: tls.instant(TranslationKeyMap._7508_MISSED_OPPORTUNITIES),
        active: !!totalMissedOpps,
        colstyle: compressedstyles.colstyle,
        styles: compressedstyles.styles,
        class: headerswithcontrolsclass,
        headerContentClass: headercontentoaclass,
        cellstyles: {
            'text-align': 'center',
        },
        // cacheStyleProps: {
        //     colstyle: { width: '210px' },
        //     styles: {
        //         width: '15%',
        //         'min-width': '210px'
        //     }
        // },
        elastic: true,
        actionSideEffects: {
            toggleCompress: toggleCompressHandler,
        },
    };
    missedCol.icon = [
        new Icon(
            {
                iconName: 'toggle',
                class: ['eye-off-outline'],
                title: [hidecolumntitle],
                counter: 0,
                state: false,
                action: 'toggleColumnByIndex',
                actionParams: [4],
            },
            TeamColumnConfigIconId.MISSED_TOGGLE,
        ),
        new Icon(
            {
                iconName: 'compress',
                class: [compressiconclass, expandiconclass],
                title: [tls.instant(compacttitle), tls.instant(fulltitle)],
                counter: 1, // by default compressed, so initial button should be expand
                state: true,
                action: 'compressColumnByIndex',
                actionParams: [4, 'toggleCompress'],
            },
            TeamColumnConfigIconId.MISSED_COMPRESS,
        ),
    ];

    const nonoaCol: any = {
        templateName: 'nonopps',
        bindToId: 0,
        header: tls.instant(TranslationKeyMap._7464_NON_OPPORTUNITY_COACHING),
        active: false,
        colstyle: {
            width: '50%',
        },
        styles: {
            width: '50%',
            'min-width': '150px',
        },
        class: headerswithcontrolsclass,
        headerContentClass: headercontentoaclass,
        cellstyles: {
            'text-align': 'center',
        },
        elastic: true,
        actionSideEffects: {
            toggleCompress: toggleCompressHandler,
        },
    };
    nonoaCol.icon = [
        new Icon(
            {
                iconName: 'toggle',
                class: ['eye-off-outline'],
                title: [hidecolumntitle],
                counter: 0,
                state: false,
                action: 'toggleColumnByIndex',
                actionParams: [5],
            },
            TeamColumnConfigIconId.NON_OA_TOGGLE,
        ),
        new Icon(
            {
                iconName: 'compress',
                class: [compressiconclass, expandiconclass],
                title: [tls.instant(compacttitle), tls.instant(fulltitle)],
                counter: 0,
                state: false,
                action: 'compressColumnByIndex',
                actionParams: [5, 'toggleCompress'],
            },
            TeamColumnConfigIconId.NON_KPI_COMPRESS,
        ),
    ];

    const nonkpiCol: any = {
        templateName: 'nonkpi',
        bindToId: 1,
        header: tls.instant(TranslationKeyMap._7465_NON_KPI),
        colstyle: {
            width: '150px',
        },
        active: false,
        styles: {
            width: '150px',
        },
        class: ['non-kpi-header border-left', headerswithcontrolsclass],
        headerContentClass: headercontentoaclass,
        cellstyles: {
            'text-align': 'center',
        },
        // elastic: true
        // icon: [
        //     {
        //         class: ['chevron-up', 'chevron-down'],
        //         counter: 0,
        //         state: true,
        //         action: 'sortTeamByScore',
        //         actionParams: {}
        //     }
        // ],
    };
    nonkpiCol.icon = [
        new Icon(
            {
                iconName: 'toggle',
                class: ['eye-off-outline'],
                title: [hidecolumntitle],
                counter: 0,
                state: false,
                action: 'toggleColumnByIndex',
                actionParams: [6],
            },
            TeamColumnConfigIconId.NON_KPI_TOGGLE,
        ),
    ];

    return [
        new ColumnConfigItem(performerCol, TeamColumnConfigId.PERFORMER),
        new ColumnConfigItem(oaCol, TeamColumnConfigId.OA),
        new ColumnConfigItem(coachedCol, TeamColumnConfigId.COACHED),
        new ColumnConfigItem(uncoachedCol, TeamColumnConfigId.UNCOACHED),
        new ColumnConfigItem(missedCol, TeamColumnConfigId.MISSED),
        new ColumnConfigItem(nonoaCol, TeamColumnConfigId.NON_OA),
        new ColumnConfigItem(nonkpiCol, TeamColumnConfigId.NON_KPI),
    ].map((g) => {
        g.index = colindex;
        colindex += 1;
        return g;
    });
}

const enum TeamColumnConfigId {
    PERFORMER = 'performer',
    OA = 'oa',
    COACHED = 'coached',
    UNCOACHED = 'uncoached',
    MISSED = 'missed',
    NON_OA = 'nonOa',
    NON_KPI = 'nonKpi',
}
const enum TeamColumnConfigIconId {
    PERFORMER_TOGGLE = 'performerToggle',
    OA_TOGGLE = 'oaToggle',
    OA_COMPRESS = 'oaCompress',
    COACHED_TOGGLE = 'coachedToggle',
    COACHED_COMPRESS = 'coachedCompress',
    UNCOACHED_TOGGLE = 'uncoachedToggle',
    UNCOACHED_COMPRESS = 'uncoachedCompress',
    MISSED_TOGGLE = 'missedToggle',
    MISSED_COMPRESS = 'missedCompress',
    NON_OA_TOGGLE = 'nonOaToggle',
    NON_KPI_TOGGLE = 'nonKpiToggle',
    NON_KPI_COMPRESS = 'nonKpiCompress',
}
